// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5981": "9200fc8d30ac","8942": "f06e52cc1430","9685": "37b0a85f4dfe",}[chunkId] + ".css"
}